@if (loading) {
<bracelit-preloader [absoluteCentered]="true">
</bracelit-preloader>
}

@if (!loading) {
<div class="event-details-container main-container"
  style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: center;">

  @if (event.hasQR) {
  <div
    style="display: flex; justify-content: flex-end; margin-bottom: 5px; margin-top: -10px; width: 100%; max-width: 300px !important">
    <button class="light-16px-center-marine" mat-raised-button type="button" (click)="onSeeQrCode()"
      style="box-shadow: none !important; background-color: transparent !important; padding: 0 !important;">
      <mat-icon svgIcon="show-qr" class="primary-color" style="width:25px; height:25px;"></mat-icon>
      {{ 'eventDetails.showQR' | translate }}
    </button>
  </div>
  }

  <div style="width: 100%; display: flex; align-items: center; justify-content: center;">
    @if (eventId !== '473afa34-c57c-460f-9de7-8700a2e225c5' && eventId !== 'dd2114eb-2c0e-48eb-98a3-205e866fd87d') {
    <mat-card class="bracelit-card white-opacity-background" style="margin-bottom: 25px !important;">
      <mat-card-header class="card-header" style="font-size: 18px !important; text-align: left !important;">
        {{wristbandsService.selectedEvent ? wristbandsService.selectedEvent.name : ' '}}
        @if (event.hasInformation && event.info !== null) {
        <div (click)="openInfo()" class="history-img-container" style="cursor: pointer; padding-right:5px;" matRipple>
          <mat-icon svgIcon="info-medium"></mat-icon>
        </div>
        }
      </mat-card-header>
      <div class="bracelit-card-content">
        <div class="bracelit-card-row">
          <div class="bracelit-card-row">
            <div style="display: flex; justify-content: space-between ;margin: 0px 8px; width: calc(100% - 16px);">
              <div class="bold-14px-left-primary" style=" margin-top: 10px">
                <span style="display: flex; flex-direction: row;"
                  [ngStyle]="{'visibility': (((wristbandsService.selectedWristband['label'] !== 'associated') && (wristbandsService.selectedWristband['label'] !== 'changed')) ? 'hidden' : 'visible')}"
                  style="
                  font-size: 15px;
                  font-style: normal;
                  font-weight: 700;
                  color: #0f223e !important;">
                  {{ 'eventDetails.code' | translate }}:
                </span>
                <span class="code-pulsera-number" style="display: flex; flex-direction: row; margin-top: -3px"
                  [ngStyle]="{'visibility': (((wristbandsService.selectedWristband['label'] !== 'associated') && (wristbandsService.selectedWristband['label'] !== 'changed')) ? 'hidden' : 'visible')}">
                  {{codeWrist}}
                </span>
              </div>
              <div style="margin-top: 30px;
                font-size: 16px;
                font-style: normal;
                font-weight: normal;
                color: #0f223e !important;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 50%">
                {{wristbandsService.selectedWristband.showName}}
              </div>
            </div>
          </div>
        </div>

        <div class="bracelit-card-row bracelit-card-row-second"
          style="display: flex; align-items: center; padding-top: 20px !important; display: flex; justify-content: space-between">
          <div style="display: flex; justify-content: left; flex-flow: row; ">
            @if (hasPurchases) {
            <div class="history-img-container" matRipple>
              <mat-icon id="historic" svgIcon="history" matTooltip="{{ 'history' | translate }}"
                (click)="onOpenHistory()" style=" cursor: pointer; color: #0f223e !important;
                fill: #0f223e !important; margin: 0px 0px 0px -17px !important"></mat-icon>
            </div>
            }
            <div class="history-img-container" style="margin: 0px !important" matRipple>
              @if (event.hasEditableData) {
              <mat-icon (click)="editEventUserForm()" class="primary-color" svgIcon="pencil-small"
                matTooltip="{{ 'editData' | translate }}"
                style=" cursor: pointer; color: #0f223e !important; fill: #0f223e !important; margin: 0px 0px 0px -17px !important"></mat-icon>
              }
            </div>
          </div>
          @if (hasPurchases) {
          <div style="display: flex; align-items: center;">
            <div class="text-adjust-bottom regular-16px-left-primary-200"
              style="display: flex; align-items: center; color: #0f223e !important;">
              {{coinName.charAt(0).toUpperCase()}}{{coinName.slice(1)}}</div>
            <div class="number-container light-20px-right-primary"
              style="display: flex; align-items: center; margin-left: 18px; color: #0f223e !important; fill: #0f223e !important;">
              {{wristbandsService.selectedWallet ? (wristbandsService.selectedWallet.money | number) : '-'}}
            </div>
            <div class="img-container" style="display: flex; align-items: center;">
              <mat-icon svgIcon="coins" style="color: #0f223e !important; fill: #0f223e !important;"></mat-icon>
            </div>
          </div>
          }
        </div>
      </div>
      @if (event.wearablesManagement) {
      <mat-slide-toggle (change)="activateOrDeactivate($event)" [checked]="checked" style="padding-left: 20px">{{checked
        ? 'Desactivar' : 'Activar'}}
      </mat-slide-toggle>
      }
    </mat-card>
    } @else {
    <img src="assets/bracelit/CONCURSO_ELEGANCIA/Logo_ConcursoElegancia.png"
      style="width: 100%; max-width: 150px; height: auto; margin-bottom: 15px; margin-left: 20px;">
    }
  </div>

  <div
    style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center; margin-top: 15px; padding-bottom: 120px;">
    @if (leadScanner && bidirectional && !productScanner) {
    <div class="product-scanner-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="product-scanner-button" class="primary-background bold-20px-center-white" mat-raised-button
        type="button" (click)="onLeadScanner()" style="box-shadow: none !important; width: 320px !important">
        Lead scanner
      </button>
    </div>
    }

    @if (event.isPaymentGatewayEnabled && eventId !== '04260fda-0945-42c8-9936-cbd73c2bfa80') {
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        (click)="onRechargeWristband()" style="width: 320px !important; box-shadow: none !important;">
        {{ 'eventDetails.recharge' | translate }} {{wristbandLabel}}
      </button>
    </div>
    }

    <!-- CHAPUZA FESTIVAL DE LAS IDEAS -->
    @if (eventId === '04260fda-0945-42c8-9936-cbd73c2bfa80') {
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        (click)="goToPopUp()" style="width: 320px !important; box-shadow: none !important;">
        Pagar fianza
      </button>
      <div style="width: 320px !important;">
        * Para utilizar los auriculares en Plaza de España y seguir las conversaciones del Festival de las Ideas, es
        necesario abonar la fianza previamente.
      </div>
    </div>
    }

    <!-- CHAPUZA BANKUNION -->
    @if (eventId === '2fb0ad84-b8c8-4004-bd0a-093d8c41aefd' && dataWrist) {
    @if (!dataWrist.socio) {
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        (click)="postBankunion()" style="width: 320px !important; box-shadow: none !important;">
        PULSERA A CRÉDITO
      </button>
      <div style="width: 320px !important;">
        * Debe pulsar este botón para confirmar que desea que su pulsera sea a crédito.
      </div>
    </div>
    }
    }

    <!-- CHAPUZA LA TAJA -->
    @if ((eventId === '7545ed70-72bc-4095-8e59-dd576d20924e') && (checkPrincipalMember() === true)) {
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        style="width: 320px !important; box-shadow: none !important; border: 1px solid #0F223E; color: #0F223E !important; background-color: white !important"
        (click)="showIframe()">
        Reservar mesa
      </button>
    </div>
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        style="width: 320px !important; box-shadow: none !important; border: 1px solid #0F223E; color: #0F223E !important; background-color: white !important"
        (click)="abrirCarta()">
        Ver carta
      </button>
    </div>
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        style="width: 320px !important; box-shadow: none !important; border: 1px solid #0F223E; color: #0F223E !important; background-color: white !important"
        (click)="redirectEditProfile()">
        Editar perfil
      </button>
    </div>
    }

    <!-- CHAPUZA FIN FUN (MBA KIDS) -->
    @if (event.id === '938c8da9-4e2e-48f6-861e-cbdd23e6695f' || event.id === '1aa82077-4f80-42e0-b46c-feaab8c12d35' ||
    event.id === '3c8d24d8-011d-4e11-a13d-c28c0ac89a28' || event.id === 'a1b35115-d4a3-4be3-8bd8-3e2414340aa0') {
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        (click)="changeFlagMBA()" style="width: 320px !important; box-shadow: none !important;">
        {{ 'eventDetails.admin' | translate }} {{wristbandLabel}}
      </button>
      @if (flagMBA) {
      <div style="width: 320px; display: flex; flex-direction: column; gap:15px; padding-top: 25px;">
        <div class="input-recarga" floatLabel="never" style="width: 320px !important">
          <input #bracelsInput="matInput" (change)="changeMoneyMBA(1, false)" (keyup)="changeMoneyMBA(1, false)"
            [formControl]="myForm.controls['money']" [id]="'bracels'" [type]="'number'" min="0" step="any"
            class="light-16px-left-marine" [placeholder]="'Introduce una cantidad €'"
            style="margin-right: 4px !important; color: #0f223e !important;" matInput>

          <div (click)="changeMoneyMBA(0, false)" class="history-img-container input-recarga" matRipple
            style="display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center; cursor: pointer; width: 36px; height: 36px; min-width: 36px; padding: 5px; border-width: 0px 0px 0px 1px; border-top-left-radius: 0px; border-bottom-left-radius: 0px;">
            <mat-icon svgIcon="right_reset_icon" class="primary-color"></mat-icon>
          </div>
        </div>
        <div style="width: 320px; display: flex; flex-direction: row; gap: 10px;">
          <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
            (click)="changeMoneyMBA(1, true)" style="width: 160px !important; box-shadow: none !important;">
            {{ 'eventDetails.add' | translate }}
          </button>
          <button mat-raised-button type="button" class="white-background regular-20px-center-marine"
            style="box-shadow: none !important; width: 160px !important; border: 1px solid #0F223E;"
            (click)="changeMoneyMBA(-1, true)">
            {{ 'eventDetails.subtract' | translate }}
          </button>
        </div>
      </div>
      }
    </div>
    }

    @if (onlineOrders) {
    <div class="buy-orders-container" style="width: 100%; display: flex; align-items: center; justify-content: center;">
      <button mat-raised-button type="button" class="bold-20px-center-marine" id="control" (click)="onBuyOnlineOrders()"
        style="box-shadow: none !important; display: flex; align-items: center; justify-content: center; width: 320px !important; border: 1px solid #0F223E; background-color: #0F223E !important; color: white !important;">
        {{ 'eventDetails.order' | translate }}
      </button>
    </div>
    }

    <!-- CHAPUZA ELF SPAIN -->
    <!-- @if (eventId === '95a6b220-2b0e-4721-86b6-82819c2d41a8') {
      <div style="margin-bottom: 25px; width: 320px; text-align: center;">
        {{ messageElfSpain }}
      </div>
    }-->

    @if (eventHasVouchers && ((eventId !== '5c539014-eaf0-4255-a3eb-288ecdb9542c') || (eventId ===
    '5c539014-eaf0-4255-a3eb-288ecdb9542c' &&
    checkInvitado() === false))) {
    <div class="associate-button-container"
      style="margin-top: 0 !important; width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <div style="display: flex; flex-direction: row;">
        <button mat-raised-button type="button" class="white-background bold-20px-center-marine" id="control2" #control
          (click)="onBuyVouchers()"
          style="box-shadow: none !important; width: 320px !important; border: 1px solid #0F223E;">
          {{ 'eventDetails.buy' | translate }} {{voucherLabelMinus}}
        </button>
      </div>
    </div>
    }

    @if (eventHasVouchers) {
    <div style="width: 100%; display: flex; align-items: center; justify-content: center; margin-bottom: 15px;">
      <div style="display: flex; flex-direction: row;">
        <div (click)="onOpenAcquiredVouchers()" style="width: auto !important; color: #0F223E; font-size: 16px; text-align: center; cursor: pointer;
                  font-style: normal; font-weight: 700; line-height: normal; border-bottom: 3px solid #0F223E;">
          {{ (currentLang === 'es') ? 'Ver bonos comprados' : 'View purchased vouchers' }}
        </div>
      </div>
    </div>
    }

    @if (event.isTicketing) {
    <div class="associate-button-container"
      style="margin-top: 0 !important; width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <div style="display: flex; flex-direction: row;">
        @if (eventId === '473afa34-c57c-460f-9de7-8700a2e225c5' || eventId === 'dd2114eb-2c0e-48eb-98a3-205e866fd87d') {
        <button mat-raised-button type="button" class="white-background bold-20px-center-marine" id="control2" #control
          (click)="onBuyTickets()"
          style="box-shadow: none !important; width: 320px !important; border: 1px solid #0F223E;">
          {{ currentLang === 'es' ? 'Pagar entrada ahora' : 'Pay ticket now' }}
        </button>
        } @else {
        <button mat-raised-button type="button" class="white-background bold-20px-center-marine" id="control2" #control
          (click)="onBuyTickets()"
          style="box-shadow: none !important; width: 320px !important; border: 1px solid #0F223E;">
          {{ 'eventDetails.book' | translate }}
          {{ticketLabelMinus}}
        </button>
        }
      </div>
    </div>

    <div style="width: 100%; display: flex; align-items: center; justify-content: center; margin-bottom: 15px;">
      <div style="display: flex; flex-direction: row;">
        @if (eventId !== '473afa34-c57c-460f-9de7-8700a2e225c5' && eventId !== 'dd2114eb-2c0e-48eb-98a3-205e866fd87d') {
        <div (click)="onViewReservedTickets()" style="width: auto !important; color: #0F223E; font-size: 16px; text-align: center; cursor: pointer;
                    font-style: normal; font-weight: 700; line-height: normal; border-bottom: 3px solid #0F223E;">
          {{ 'eventDetails.viewReservedTickets' | translate }}
        </div>
        } @else {
        <div (click)="onViewReservedTickets()" style="width: auto !important; color: #0F223E; font-size: 16px; text-align: center; cursor: pointer;
                    font-style: normal; font-weight: 700; line-height: normal; border-bottom: 3px solid #0F223E;">
          {{ currentLang === 'es' ? 'Ver todas mis entradas' : 'View all my tickets' }}
        </div>
        }
      </div>
    </div>
    }

    <!-- CHAPUZA FEX -->
    @if (eventId === '752a6617-0e88-4c82-b2d8-a736a7a8ea17') {
    <div style="margin-bottom: 5px; width: 320px; text-align: center; font-size: 12px;">
      La adquisición de invitaciones online se activará desde el domingo previo a cada espectáculo a las 10:00h y se
      desactivará una hora antes del inicio del mismo.
    </div>
    <div style="margin-bottom: 25px; width: 320px; text-align: center; font-size: 12px;">
      Haga un consumo responsable de las invitaciones. Reserve solo si tiene el convencimiento de que asistirá. Cancele
      sus invitaciones antes del concierto si finalmente no va a asistir.
    </div>
    }

    <!-- CHAPUZA EL LAGARILLO -->
    @if ((eventId === 'cc9785a4-cd8e-432c-89c8-ee5f40423e7c' || eventId === '55e5246b-79fb-445c-a697-d51b514f3c6a') &&
    dataWrist) {
    @if (dataWrist.name && !dataWrist.invitado) {
    <div style="margin-top: 40px">Nombre: {{dataWrist.name}}</div>
    }
    @if (dataWrist.surname && !dataWrist.invitado) {
    <div style="margin-top: 10px">Apellidos: {{dataWrist.surname}}</div>
    }
    @if (dataWrist.genero && !dataWrist.invitado) {
    <div style="margin-top: 10px">Género: {{dataWrist.genero}}</div>
    }
    @if (dataWrist.genero === 'Mujer' && dataWrist.taquilla && !dataWrist.invitado) {
    <div style="margin-top: 10px">Taquilla: {{dataWrist.taquilla}}</div>
    }
    }

    <!-- CHAPUZA CASETA LA REJA -->
    @if (eventId === '0de9e703-0492-48d5-aa05-76bc88e1950a' && dataWrist) {
    @if (dataWrist.name) {
    <div style="margin-top: 40px">Nombre: {{dataWrist.name}}</div>
    }
    @if (dataWrist.number) {
    <div style="margin-top: 10px">Número: {{dataWrist.number}}</div>
    }
    }

    <!-- CHAPUZA EVENTIK -->
    @if (eventId === '47c562a9-5e1f-4840-a064-80115062f386') {
    <div class="recharge-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <button id="recharge-button" class="primary-background bold-20px-center-white" mat-raised-button type="button"
        (click)="goToQuestionary()" style="width: 320px !important; box-shadow: none !important;">
        Quiniela
      </button>
    </div>
    <div class="associate-button-container"
      style="margin-top: 0 !important; width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      <div style="display: flex; flex-direction: row;">
        <button mat-raised-button type="button" class="white-background bold-20px-center-marine" id="control2" #control
          (click)="goToQuiz()" style="box-shadow: none !important; width: 320px !important; border: 1px solid #0F223E;">
          Concurso fotografía
        </button>
      </div>
    </div>
    }

    @if (event.isMoneyReturned && (wristbandsService.selectedWristband['label'] === 'associated' ||
    wristbandsService.selectedWristband['label'] === 'changed' || !obligatoryAssociation || event.isTicketing ||
    event.hasQR)) {
    <div
      style="position: absolute; bottom: 70px; width: 100%; background: #FFFFFF; width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
      @if (errorReturnNumber === 1) {
      <div style="display: flex; flex-direction: row;" class="noAssociated">
        {{ 'eventDetails.errorReturn1' | translate }}
      </div>
      }
      @if (errorReturnNumber === 2) {
      <div style="display: flex; flex-direction: row;" class="noAssociated">
        {{ 'eventDetails.errorReturn2' | translate }}
      </div>
      }
      <div style="display: flex; flex-direction: row;">
        <div (click)="goToMoneyReturned()" style="width: auto !important; color: #0F223E; font-size: 18px; text-align: center; cursor: pointer;
                font-style: normal; font-weight: 700; line-height: normal; border-bottom: 3px solid #0F223E;">
          {{ 'eventDetails.return' | translate }}
        </div>
      </div>
    </div>
    }

    @if (intervalReturnMoneyStarting && intervalReturnMoneyEnding && (wristbandsService.selectedWristband['label'] ===
    'associated' || wristbandsService.selectedWristband['label'] === 'changed' || !obligatoryAssociation ||
    event.isTicketing || event.hasQR)) {
    <div class="associate-button-container"
      style="width: 100%; display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center; position: absolute; bottom: 0;  height: 50px; width: 100%; background: #FFFFFF;">
      <div style="display: flex; flex-direction: row;">
        <div (click)="openInfoDev()" style="width: auto !important; color: #0F223E; font-size: 18px; text-align: center; cursor: pointer;
                font-style: normal; font-weight: 700; line-height: normal; border-bottom: 3px solid #0F223E;">
          {{ 'eventDetails.infoDev' | translate }}
        </div>
      </div>
    </div>
    }

    @if (this.wristbandsService.selectedWristband['label'] !== 'associated' && obligatoryAssociation && eventId !==
    '752a6617-0e88-4c82-b2d8-a736a7a8ea17') {
    <div
      style="display: flex; flex-direction: column; display: flex; justify-content: center; align-items: center;
          border-radius: 30px 30px 0px 0px; background: #D9D9D9; position: absolute; bottom: 0; width: 100%; z-index: 900;">
      <div class="noAssociated" style="width: 100%; display: flex; align-items: center; justify-content: center;">
        {{ 'eventDetails.messageAssociate' | translate }}
      </div>
      <div>
        <button type="button" class="bold-16px-center-marine" (click)="onNavigateToNewWristband()"
          style="border: 1px solid #0F223E; border-radius: 50px; padding: 7px 15px !important; background-color: transparent;
            margin-bottom: 20px; box-shadow: none; display: flex; justify-content: center; align-items: center; cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"
            style="padding-right: 7px;">
            <path
              d="M13.6357 7.71819L13.6457 7.71919C14.6032 7.91538 15.4817 8.38906 16.1717 9.08119C16.8633 9.7726 17.3371 10.6515 17.5347 11.6092C17.6696 12.2745 17.6693 12.9601 17.5337 13.6252C17.3376 14.5831 16.8635 15.4621 16.1707 16.1522L17.5847 17.5662C18.5526 16.5977 19.2159 15.3671 19.4927 14.0262C19.6845 13.0963 19.6845 12.1371 19.4927 11.2072C19.2192 9.86556 18.5558 8.63449 17.5857 7.66819C16.9488 7.02901 16.1939 6.51958 15.3627 6.16819C14.9391 5.98882 14.4986 5.85214 14.0477 5.76019C13.9107 5.73219 13.7727 5.71719 13.6357 5.69719V2.61719L9.63575 6.61719L13.6357 10.6172V7.71819ZM6.18575 15.3412C6.35975 15.7532 6.57775 16.1532 6.83175 16.5312C7.08075 16.9012 7.36875 17.2492 7.68575 17.5652C8.32394 18.2035 9.079 18.7131 9.90975 19.0662C10.3347 19.2462 10.7777 19.3832 11.2247 19.4742C11.3917 19.5082 11.5627 19.5302 11.7327 19.5522V22.4962L15.7327 18.4962L11.7327 14.4962V17.5262C11.6977 17.5202 11.6607 17.5232 11.6257 17.5152C10.6683 17.319 9.78979 16.8453 9.09975 16.1532C8.63482 15.6892 8.26597 15.1381 8.01434 14.5314C7.76271 13.9247 7.63323 13.2743 7.63333 12.6175C7.63342 11.9607 7.76308 11.3103 8.01488 10.7037C8.26669 10.097 8.63568 9.54601 9.10075 9.08219L7.68675 7.66719C7.04824 8.30505 6.53892 9.06021 6.18675 9.89119C5.82193 10.7536 5.63453 11.6807 5.63575 12.6172C5.63511 13.5528 5.82213 14.4791 6.18575 15.3412Z"
              fill="#0F223E" />
          </svg>
          {{ 'eventDetails.buttonAssociate' | translate }}
        </button>
      </div>
    </div>
    }
  </div>

  @if (eventId === '47c562a9-5e1f-4840-a064-80115062f386') {
  <div style="position: absolute; bottom: 0">
    <img [src]="'app/shared/assets/images/BANNER-CONGRESO-GIJON-2024.jpg'" alt=""
      style="width: 100% !important; height: auto !important; max-width: 768px;">
  </div>
  }
</div>
}